/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CloseWorkDayResponseDto } from '../../models/close-work-day-response-dto';

export interface GlsControllerCloseShipments$Params {
}

export function glsControllerCloseShipments(http: HttpClient, rootUrl: string, params?: GlsControllerCloseShipments$Params, context?: HttpContext): Observable<StrictHttpResponse<CloseWorkDayResponseDto>> {
  const rb = new RequestBuilder(rootUrl, glsControllerCloseShipments.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CloseWorkDayResponseDto>;
    })
  );
}

glsControllerCloseShipments.PATH = '/couriers/gls/close-work-day';
